import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { DOCUMENT_REGLEMENTAIRE } from './mutation-types';
import { DocumentReglementaireState, initialState as resetState } from './state';
import { DocumentReglementaire } from '@/models/DocumentReglementaire';
import { TypeDocumentReglementaire } from '@/models/TypeDocumentReglementaire';
import { AnalyseDeRisqueDTO } from '@/models/AnalyseDeRisqueDTO';
import { PriseEnChargeDTO } from '@/models/PriseEnChargeDTO';

export const mutations: MutationTree<DocumentReglementaireState> = {
    [DOCUMENT_REGLEMENTAIRE.SET_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire = items;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire = items;
    },
    [DOCUMENT_REGLEMENTAIRE.ADD_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire = [...state.documentReglementaire, ...items];
    },
    [DOCUMENT_REGLEMENTAIRE.SET_ITEMS_ADR](state, items: AnalyseDeRisqueDTO[]) {
        state.adr = items;
    },
    [DOCUMENT_REGLEMENTAIRE.ADD_ITEMS_ADR](state, items: AnalyseDeRisqueDTO[]) {
        state.adr = [...state.adr, ...items];
    },
    [DOCUMENT_REGLEMENTAIRE.SET_ITEMS_PEC](state, items: PriseEnChargeDTO[]) {
        state.prisesEnCharge = items;
    },
    [DOCUMENT_REGLEMENTAIRE.RESET_ITEMS](state) {
        state.documentReglementaire = [];
        state.adr = [];
        state.prisesEnCharge = [];
        state.page = 0;
        state.count = 0;
    },
    [DOCUMENT_REGLEMENTAIRE.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [DOCUMENT_REGLEMENTAIRE.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_GROUPE](state, groupeList: Array<number>) {
        state.filterGroupe = groupeList;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_SOUS_GROUPE](state, sousGroupeList: Array<number>) {
        state.filterSousGroupe = sousGroupeList;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_EQUIPEMENT](state, equipementList: Array<number>) {
        state.filterEquipement = equipementList;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_DOCUMENT_TYPE](state, documentTypeList: Array<TypeDocumentReglementaire>) {
        state.filterDocumentType = documentTypeList;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_DOCUMENT_DATE_TO](state, value: string) {
        state.filterDocumentDateTo = value;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_FILTER_DOCUMENT_DATE_FROM](state, value: string) {
        state.filterDocumentDateFrom = value;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.sort = sort;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_SORT_ADR](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.tableAdrHeader = state.tableAdrHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.sort = sort;
    },
    [DOCUMENT_REGLEMENTAIRE.RESET](state) {
        Object.assign(state, resetState);
    },
    [DOCUMENT_REGLEMENTAIRE.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_ZIP_IS_LOADING](state, isLoading: boolean) {
        state.isZipLoading = isLoading;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_COUNT_FOR_MODAL](state, nombreDocuments: number) {
        state.nombreDocumentModal = nombreDocuments;
    },
    [DOCUMENT_REGLEMENTAIRE.SET_TYPES_DOCUMENTS](state, typesDocuments: TypeDocumentReglementaire[]) {
        state.typesDocumentsReglementaires = typesDocuments;
    },
};
